import React from 'react';

import { BlockWrapper } from '../../block-wrapper/block-wrapper';
import { RenderBlocks } from '../../blocks/render-blocks';
import { IMeetingPlacePageEditorialFullWidth } from '@/lib/fragments/meetingPlacePageEditorialFullWidth';

interface EditorialPageFullWidthProps {
  page: IMeetingPlacePageEditorialFullWidth;
  integrationId?: string;
  node_locale: string;
}

export interface TextArrayProps {
  title?: string;
  preamble?: string;
  cardType?: string;
  topItem?: boolean;
}

export const EditorialPageFullWidth = ({
  page,
  integrationId,
  node_locale,
}: EditorialPageFullWidthProps) => {
  const blocksCollection = page?.blocksCollection?.items?.filter(Boolean) || [];
  const topBlock =
    blocksCollection?.length >= 0 ? blocksCollection[0]?.blocktype : '';
  const titleCheckArray = blocksCollection?.filter((x: any) => {
    return x.blocktype !== 'BlockEditorialFullWidthImageMosaic';
  });
  const titleArrayTopBlock =
    titleCheckArray && titleCheckArray.length > 0
      ? titleCheckArray[0]?.blocktype
      : '';

  let check = 0;
  const textItem = blocksCollection?.map((block: any) => {
    switch (block?.blocktype) {
      case 'BlockEditorialFullWidthCarousel':
        check++;
        return block?.carouselItemsCollection?.items
          ?.filter(Boolean)
          ?.map(({ title, preamble }: TextArrayProps, index: number) => {
            return (titleArrayTopBlock as string) ===
              'BlockEditorialFullWidthCarousel' &&
              index === 0 &&
              check === 1 &&
              (title || preamble)
              ? { title, preamble, topItem: true }
              : { title, preamble, topItem: false };
          });
      case 'BlockEditorialFullWidthColumn':
        check++;
        return block?.columnListCollection?.items
          ?.filter(Boolean)
          ?.map(({ title, preamble }: TextArrayProps, index: number) => {
            return (titleArrayTopBlock as string) ===
              'BlockEditorialFullWidthColumn' &&
              index === 0 &&
              check === 1 &&
              (title || preamble)
              ? { title, preamble, topItem: true }
              : { title, preamble, topItem: false };
          });
      case 'BlockEditorialFullWidthImageAndText':
        check++;
        return (titleArrayTopBlock as string) ===
          'BlockEditorialFullWidthImageAndText' &&
          (block.title || block.preamble) &&
          check === 1
          ? {
              title: block.title,
              preamble: block.preamble,
              topItem: true,
            }
          : {
              title: block.title,
              preamble: block.preamble,
              topItem: false,
            };
      case 'BlockEditorialFullWidthBanner':
        check++;
        return (titleArrayTopBlock as string) ===
          'BlockEditorialFullWidthBanner' &&
          (block.title || block.preamble) &&
          check === 1
          ? {
              title: block.title,
              preamble: block.preamble,
              topItem: true,
            }
          : {
              title: block.title,
              preamble: block.preamble,
              topItem: false,
            };
      default:
        break;
    }
  });

  return (
    <div
      className={
        'grid grid-cols-11 gap-6 pt-0 sm:pt-5 lg:gap-5 ' +
        ((topBlock as string) === 'BlockEditorialFullWidthImageMosaic' ||
        (topBlock as string) === 'BlockEditorialFullWidthColumn' ||
        (topBlock as string) === 'BlockEditorialFullWidthCarousel'
          ? 'pt-5 sm:pt-0 '
          : '')
      }
    >
      <div className="col-span-11 lg:pl-21">
        {page?.blocksCollection && (
          <div
            className={
              'mx-auto w-full bg-brand-white sm:px-6 lg:mx-0 lg:mb-5 lg:px-0 lg:pt-0 ' +
              ((topBlock as string) !== 'BlockEditorialFullWidthBanner'
                ? 'sm:px-5 '
                : '')
            }
          >
            {blocksCollection?.map((block, index) => {
              return (
                <BlockWrapper
                  key={index}
                  className={
                    '!mb-5 bg-transparent !pb-0 last:!mb-0 sm:p-0 md:p-0 lg:!p-0 xl:p-0 '
                  }
                >
                  <RenderBlocks
                    blocks={[block]}
                    integrationId={integrationId}
                    node_locale={node_locale}
                    topBlock={
                      topBlock === block.blocktype && index === 0 ? true : false
                    }
                    textItem={textItem?.[index]}
                  />
                </BlockWrapper>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
